import React, { CSSProperties } from "react";
import styles from "./section-layout.module.scss";
import classNames from "classnames";

type Props = {
  children: React.ReactNode;
  style?: CSSProperties;
  gradient?: boolean;
  fullWidth?: boolean;
};

const SectionLayout = ({ children, style, gradient, fullWidth = false }: Props) => {
  return (
    <div className={classNames(styles.sectionContainer, gradient && styles.gradient, fullWidth && styles.noPadding)} style={style}>
      {children}
    </div>
  );
};

export default SectionLayout;
